function About() {
    return (
        <html lang="en">

            <head>


            </head>


            <p style={{ textAlign: 'center' }}>The purpose of this site is to give people a platform to buy and sell used EV batteries,
                <br />this will help aid with a recycling problem <br />
                that many experts predict will be very big.</p>
            <u><h1 style={{ textAlign: 'center' }}>FAQ</h1>
            </u>
            <p>
                <ul>
                    Why can only car dealers sell batteries?

                    EV batteries can be dangerous and safety is a top priority for ReCell. This is why only certified car dealers can test battery life and list batteries online.
                </ul>
                <ul>
                    Can anyone buy batteries?

                    Anyone can buy batteries for a second life. They can be used to back up solar panels, power street lights and so much more.


                    After a battery has “completed” its second life it is bought by our recycling partners who are able to reclaim 95% of the materials.
                </ul>
                <ul >
                    How do I sell my EV battery?

                    Contact your local dealer who has partnered with ReCell. They will test your battery capacity, then list it on ReCell. Your dealer will pay you or give you money off of your next battery!
                    Hint: Find a local dealer here! (link here to website part that does this)
                </ul >
                <ul >
                    Why sell my EV battery?

                    If you own an EV chances are you are already going green. ReCell can make your car even greener by diverting waste from landfills and maxing out
                    its useful life.
                </ul >
            </p>
        </html>
    );
}


export default About;